const initialData = {
    cpf: "",
    rg: "",
    cnh: "",
    sex: "",
    eyes: "",
    name: "",
    color: "",
    father: "",
    height: "",
    mother: "",
    phones: [],
    attachs: [],
    dtBirth: "",
    articles: [],
    hairSize: "",
    hairType: "",
    homeless: false,
    nickname: "",
    addresses: [],
    bodyShape: "",
    emitterRg: "",
    hairColor: "",
    roleCrime: "",
    situation: "",
    criminalRg: "",
    occupation: "",
    socialName: "",
    cityOfBirth: "",
    information: "",
    nationality: "",
    maritalStatus: "",
    socialNetwork: "",
    mentalDisorder: "",
    alcoholDrugDependency: false,
    educationDegree: "",
    relatedPhotoFaceId: "",
    relatedsPhotoAttachId: [],
    individualRegionWrapper: []
}

export default initialData;
